import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import CompanyCreateForm from './CompaniesCreateForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
}));

function CompaniesCreateView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Example Template | Agregar Compañía"
    >
      <Container maxWidth={false}>
        <Header />
        <CompanyCreateForm />
      </Container>
    </Page>
  );
}

export default CompaniesCreateView;
